import { useState } from 'react';
import { POSTER_PLACEHOLDER } from '@/lib/image';

interface PosterImageProps {
	src: string;
	alt: string;
	className?: string;
	/** Poster hero/above-the-fold nên tắt lazy để hiện nhanh. */
	eager?: boolean;
}

/**
 * <img> có fallback khi CDN trả 404 — khá thường xuyên với các bản ghi cũ
 * trong kho phim.
 */
export function PosterImage({
	src,
	alt,
	className = '',
	eager = false,
}: PosterImageProps) {
	const [failedSrc, setFailedSrc] = useState<string | null>(null);
	const isBroken = failedSrc === src;

	return (
		<img
			src={isBroken ? POSTER_PLACEHOLDER : src}
			alt={alt}
			className={className}
			loading={eager ? 'eager' : 'lazy'}
			decoding="async"
			onError={() => setFailedSrc(src)}
		/>
	);
}
